import AssetClassTable from './assetClassTable'
export default AssetClassTable
